import React from "react";
import PropTypes from "prop-types";
import Icon from 'SF/MaterialIcon';
import css from './SurveyInformation.css';
import ReactTooltip from 'react-tooltip';

export default class SurveyInformation extends React.PureComponent {

  onClick() {
    ReactTooltip.hide();
    this.props.onClick();
  }

  render() {
    return (
      <div
        onClick={this.onClick.bind(this)}
        aria-label="Info about feedback options."
        data-tip="Info about feedback <br> options."
        className={css['information-button']}
        tabIndex="0"
        role="button">
        <Icon icon="info" className={css['information-icon']} />
        <ReactTooltip
          className={css['tooltip']}
          multiline
          effect="solid"
          place="bottom"
        />
      </div>
    );
  }
}

SurveyInformation.propTypes =  {
  onClick: PropTypes.func.isRequired,
};
